export enum WidgetsPaymentMethodCode {
  POINT = "POINT",
  CARD = "CARD",
  VIRTUAL_ACCOUNT = "VIRTUAL_ACCOUNT",
  TRANSFER = "TRANSFER",
  FOREIGN_EASY_PAY = "FOREIGN_EASY_PAY",
}
